import { useMutation } from 'react-query';
import useCreateVodThemeMutation from './useCreateVodThemeMutation.js';
import { useUpdateVodSettingsMutation } from 'hooks/index.js';

const useCreateVodThemeAndMakeDefaultMutation = (options) => {
  const { mutateAsync: createVodTheme } = useCreateVodThemeMutation();
  const { mutateAsync: updateSettings } = useUpdateVodSettingsMutation();

  return useMutation({
    mutationFn: async (params) => {
      const {
        body: { themeId },
      } = await createVodTheme(params);
      if (!themeId) return;
      await updateSettings({ defaultThemeId: themeId });
    },
    ...options,
  });
};

export default useCreateVodThemeAndMakeDefaultMutation;
